import React from 'react'
import Link from 'gatsby-link'
import Aux from "../components/aux";
import If from "../components/if";
import Map from "../components/map";
import Hero from "../components/hero";
import Container from "../components/container";
import HomepageServices from "../components/homepage-services";
import HomepageProjects from "../components/homepage-projects";
import HomepageInterests from "../components/homepage-interests";
import { SERVICES, PROJECTS } from "../data";

const IndexPage = () => (
  <main>
    <Hero />
    <HomepageServices services={SERVICES} />
    <HomepageProjects projects={PROJECTS} />
    <HomepageInterests />
  </main>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js